module.exports = __webpack_public_path__ + "img/islang.50ab2dd9.png";